import Store from '../store/store'

export default {
    computed: {
        user() {
            return Store.state.user
        }
    },
    methods: {
        getUserSongs(page, limit = 20) {
            return this.$http.get(`${ab.apiUrl}/users/${this.user.id}/songs`, {params: {page: page, limit: limit}})
        },
        getUserSong(id) {
            return this.$http.get(`${ab.apiUrl}/users/${ab.user.id}/songs/${id}`)
        },
    }

}